import { Badge } from '@chakra-ui/react';

import { enrolmentHealthMetadata } from './constants';

export function EnrolmentHealthBadge({
  health,
}: {
  health: keyof typeof enrolmentHealthMetadata;
}): React.ReactElement {
  const { label, color, variant } = enrolmentHealthMetadata[health];

  return (
    <Badge
      fontSize="xs"
      fontWeight="bold"
      borderRadius="full"
      colorScheme={color}
      variant={variant}
      textTransform="none"
      whiteSpace="nowrap"
    >
      {label}
    </Badge>
  );
}
